import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import WebinarCandidatesList from '../webiner/WebinarCandidatesList';

const Interview = () => {

  const navigate = useNavigate();

  return (
    <div className='max-w-[90%] mx-auto'>
      <div className="px-0 py-3 flex items-center gap-4 sticky top-0 backdrop-blur-lg z-50">
        <button
          className="p-2 rounded-full hover:shadow-lg hover:bg-gray-200 backdrop-blur-lg transition-all duration-300 ease-in-out"
          onClick={() => navigate(-1)}
        >
          <ChevronLeft className='size-4'/>
        </button>
        <h1 className="text-xl font-semibold text-stone-600">
          Interview Candidates
        </h1>
      </div>
      <WebinarCandidatesList />
    </div>
  );
}

export default Interview